var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',{attrs:{"title":"金融计算器","left-arrow":""},on:{"click-left":function($event){return _vm.$page.close()}}},[_c('FinancialOrder',{ref:"financialOrder",attrs:{"isPure":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }